import React, { memo, useCallback } from 'react';

import { openChat } from 'app-components/flux/ai-chat';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { tracker } from 'app-components/utils/core';
import { useAppDispatch, useAppSelector } from 'hooks/redux';

import AILauncher from 'components/AIComponents/AILauncher';
import { trackingEvents } from 'containers/SimplifiAiAssistant/AiAssistant/aiEvents';

import { trackTopBarNavMenuClick } from './trackTopBarNavMenuClick';

type TopBarAIButtonProps = {
  id?: string;
};

const TopBarAIButton = memo(function TopBarAIButton({ id }: TopBarAIButtonProps) {
  const dispatch = useAppDispatch();

  const aiChatV2Enabled = useAppSelector((state) => featureFlagsSelectors.getFeatureFlags(state).get('aiChatV2'));
  const aiChatBtnTopbarEnabled = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlags(state).get('aiChatBtnTopbar'),
  );
  const [gsfScreen] = usePreferenceV2('gsfScreen');
  const [aiEnabled] = usePreferenceV2('aiInsightsOptIn');
  const completedOnboarding = gsfScreen === 'completed_gsf';

  const handleClick = useCallback(() => {
    tracker.track(trackingEvents.AIChatClick, { variant: 'topbar_ask_assist' });
    trackTopBarNavMenuClick({ menuItem: 'Ask AI', section: 'topbar-ai' });
    dispatch(openChat());
  }, [dispatch]);

  if (!aiChatV2Enabled || !aiChatBtnTopbarEnabled || !aiEnabled || !completedOnboarding) {
    return null;
  }

  return (
    <AILauncher
      id={id ?? 'topbar-ask-assist'}
      variant='full'
      size='medium'
      color='primary'
      label='Ask AI'
      icon='ai-logo-icon'
      borderAnimation='both'
      onClick={handleClick}
    />
  );
});

export default TopBarAIButton;
